/** EvolveRPG — English overrides for the commerce feature. Fast-play, momentum-driven voice. */
export const commerceEvoEn = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoDescription': 'Import your DriveThruRPG library and claim your EvolveRPG PDFs.',
  'commerce.dtrpg.intro':
    'Bought EvolveRPG on DriveThruRPG or backed the campaign? Sign in with your purchase email to import your library and claim your copies.',
  'commerce.dtrpg.checkInboxSuffix':
    'If that email backed or bought EvolveRPG, a sign-in link is on its way — click it to return here and claim your library.',
  'commerce.dtrpg.libraryHeading': 'Your EvolveRPG library',

  // PaywallPrompt.tsx
  'commerce.paywall.vaultSealed': 'Checkout is locked for now — please try again soon.',
  'commerce.paywall.openingVault': 'Opening checkout…',

  // MarketplacePage.tsx
  'commerce.marketplace.loading': 'Loading your packs…',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.intro':
    'Back the hosts and creators you love — and unlock the perks they save for their regulars.',
  'commerce.subscriber.activeBlurb': 'Your perks are active. Look for the subscriber badge on tables you can join.',
  'commerce.subscriber.paywallTitle': 'EvolveRPG Subscriber',
  'commerce.subscriber.paywallBlurb': 'Unlock subscriber-only tables, early content, and your subscriber badge.',

  // TicketCheckoutPage.tsx
  'commerce.ticket.notFoundBlurb': 'This table may have wrapped, or its doors were never opened.',
  'commerce.ticket.freeBlurb': 'No ticket required — pull up a chair.',

  // TipGoalManagerPage.tsx
  'commerce.tip.goalLabelPlaceholder': 'Goal label (e.g. Reach the boss fight)',
  'commerce.tip.bountyLabelPlaceholder': 'Bounty label (e.g. Nat 20 saves the run)',
  'commerce.tip.loading': 'Loading the ledger…',
  'commerce.tip.loadErrorTitle': 'Could not load the ledger',
}
